import React from 'react';
import {IMaskMixin} from 'react-imask';
import InputText from './InputText';
import {MaskedPattern} from 'imask';

const mask = new MaskedPattern({mask: '{(#00) 000-0000}', definitions: {'#': /[2-9]/}});

const MaskedInput = IMaskMixin(({inputRef, ...props}) => (
    <InputText {...(props as any)} InputLabelProps={{shrink: true}} ref={inputRef} />
));

const InputPhone = (props: any) => {
    return (
        <MaskedInput
            label={props.label}
            mask={mask}
            value={props.value}
            onAccept={(value) => {
                const unmaskedValue = value.replace(/[^0-9]/g, '');
                props?.onChange(unmaskedValue);
            }}
            {...(props.classes && {classes: props.classes})}
            placeholder="(555) 123-4567"
        />
    );
};

export default InputPhone;
